import React, { useState, useEffect, useRef, useContext } from "react";
import "./Products.css";
import { Container, Col, Row, Tab, Tabs } from "react-bootstrap";
import ProductImg from "./../../../Images/home-products/equity.png";
import Ipo from "./../../../Images/home-products/ipo.png";
import Etf from "./../../../Images/home-products/etf.png";
import Currency from "./../../../Images/home-products/currency.png";
import MutualFund from "./../../../Images/home-products/mutual-fund.png";
import Commodities from "./../../../Images/home-products/commodities.png";
import FutureOptions from "./../../../Images/home-products/futureoptions.png";
import ReadMore from "../../CommonUI/ReadMoreBtn/ReadMore";
import LoginPopup from "../../CommonUI/LoginPopup/LoginPopup";
import { useSelector, useDispatch } from 'react-redux';
import { userSelector, clearState } from '../../features/User/UserSlice';
import { useNavigate } from "react-router-dom";
function Products(props) {
  const [show, setShow] = useState(false);
    const childRef = useRef(null);
    const dispatch = useDispatch();
    const usrname = useSelector(state => state.user.email);
    const {  isSuccess, isError, errorMessage } = useSelector(
        userSelector
    );
    let tabName = "Stocks";

    let navigate = useNavigate();
    useEffect(() => {
        if (isSuccess) {
            setShow(false);

        }
        if (isError) {
            dispatch(clearState());
        }
    }, [isSuccess, isError]);

    const clickToggleLoginPopup = (showhide,path) => {
        if (isSuccess) {
          navigate(path);
        }
        else {
            childRef.current.changeTogglePopup(showhide);
       }
    }
  
  const routeChange = () => {
    let path = `/market/stocks`;
    clickToggleLoginPopup(true,path)
   // navigate(path);
  };
  const routeChangeIpo = () => {
    let path = `/market/ipo`;
    clickToggleLoginPopup(true,path)
    //navigate(path);
  };
  const routeChangeETF = () => {
    let path = `/market/etf`;
    clickToggleLoginPopup(true,path)
    //navigate(path);
  };
  const routeChangeCurrencyProduct = () => {
    let path = `/market/currency`;
    clickToggleLoginPopup(true,path)
    //navigate(path);
  };
  const routeChangeMF = () => {
    let path = `/market/mutual-funds`;
    clickToggleLoginPopup(true,path)
    // navigate(path);
  };
  const routeChangeCommodities = () => {
    let path = `/market/commodity`;
    clickToggleLoginPopup(true,path)
    //navigate(path);
  };

  const routeChangeFnO = () => {
    let path = `/market/futures-and-options`;
    clickToggleLoginPopup(true,path)
    //navigate(path);
  };

  return (
    <>
      <section className="products productshome_section">
        <Container className="add-border">
          <div className="homeproduct_section">
          <Row>
            <Col md={12}>
              <h2>
                <span>Products</span>
              </h2>
              <Tabs
                defaultActiveKey="equity"
                transition={true}
                id="noanim-tab-example"
                className="mb-3"
              >
                <Tab eventKey="equity" title="Equity">
                  <Row>
                    <Col md={6}>
                      <img
                        className="img-fluid product-img"
                        src={ProductImg}
                        alt="im-equity"
                      />
                    </Col>
                    <Col md={6}>
                      <div className="product-beta">
                        <p>
                        Equity is also known as shareholders equity. Equity consists of money that would remain if company assets were sold and all of its debt was paid off. In a nutshell, equity is a company net asset less liabilities. Equity is the company capital raised, which is then used to purchase assets, invests in projects, and acquisitions
                          <span onClick={routeChange}>
                            <ReadMore name="Read" />
                          </span>
                        </p>

                        {/* <button>Sign Up</button> */}
                      </div>
                    </Col>
                  </Row>
                </Tab>
                <Tab eventKey="ipo" title="IPO">
                  <Row>
                    <Col md={6}>
                      <img
                        className="img-fluid product-img"
                        src={Ipo}
                        alt="image-ipo"
                      />
                    </Col>
                    <Col md={6}>
                      <div className="product-beta">
                        <p>
                        IPO is a public offering in which a private company (that has a handful of shareholders) is taken public by listing it on the stock exchange and offering its shares to investors in the primary market. A process used in IPO helps in efficient price discovery of the securities. The issuer provides a price band within which investors may bid, and the final price is determined by the issuer only after the bidding process has concluded. Prospective buyers are given information about the proposed offering in the form of a lengthy document known as a prospectus.
                          <span onClick={routeChangeIpo}>
                            <ReadMore name="Read" />
                          </span>
                        </p>

                        {/* <button>Sign Up</button> */}
                      </div>
                    </Col>
                  </Row>
                </Tab>
                <Tab eventKey="mutualFund" title="Mutual Fund">
                  <Row>
                    <Col md={6}>
                      <img
                        className="img-fluid product-img"
                        src={MutualFund}
                        alt="image-mf"
                      />
                    </Col>
                    <Col md={6}>
                      <div className="product-beta">
                        <p>
                        A mutual fund is a financial vehicle that draws money from investors and invests those funds in various securities. The mutual fund's holdings are referred to as its portfolio. Professional money managers manage the fund and allocate funds in order to generate the best returns for the investors...
                          <span onClick={routeChangeMF}>
                            <ReadMore name="Read" />
                          </span>
                        </p>

                        {/* <button>Sign Up</button> */}
                      </div>
                    </Col>
                  </Row>
                </Tab>
                <Tab eventKey="futuresOptions" title="Futures & Options">
                  <Row>
                    <Col md={6}>
                      <img
                        className="img-fluid product-img"
                        src={FutureOptions}
                        alt="image-futuers"
                      />
                    </Col>
                    <Col md={6}>
                      <div className="product-beta">
                        <p>
                        Futures are an exchange-traded standardized derivative agreement to buy or sell the underlying asset at a pre-determined price on a specific date. A stock, index, currency, or commodity can serve as the underlying asset. The contract is directly executed via a regulated and organized exchange and the parties of the futures contract are obligated to carry out the terms of the agreement....
                          <span onClick={routeChangeFnO}>
                            <ReadMore name="Read" />
                          </span>
                        </p>

                        {/* <button>Sign Up</button> */}
                      </div>
                    </Col>
                  </Row>
                </Tab>
                <Tab eventKey="currency" title="Currency">
                  <Row>
                    <Col md={6}>
                      <img
                        className="img-fluid product-img"
                        src={Currency}
                        alt="image-currency"
                      />
                    </Col>
                    <Col md={6}>
                      <div className="product-beta">
                        <p>
                        Foreign exchange is the most liquid, decentralised, over-the-counter market, with a daily volume of more than $6.6 trillion in 2019. Individuals and institutions from all over the world buy and sell currencies on the currency market...
                          <span onClick={routeChangeCurrencyProduct}>
                            <ReadMore name="Read" />
                          </span>
                        </p>

                        {/* <button>Sign Up</button> */}
                      </div>
                    </Col>
                  </Row>
                </Tab>
                <Tab eventKey="commodities" title="Commodities">
                  <Row>
                    <Col md={6}>
                      <img
                        className="img-fluid product-img"
                        src={Commodities}
                        alt="image-commodities"
                      />
                    </Col>
                    <Col md={6}>
                      <div className="product-beta">
                        <p>
                        A commodity market is one that deals in trading raw materials or primary products rather than manufacturing products, such as cocoa, fruit, and sugar. Commodity pricing is primarily influenced by economic development and technological advances, supply, demand, and scarcity....
                          <span onClick={routeChangeCommodities}>
                            <ReadMore name="Read" />
                          </span>
                        </p>

                        {/* <button>Sign Up</button> */}
                      </div>
                    </Col>
                  </Row>
                </Tab>
                <Tab eventKey="etf" title="ETF">
                  <Row>
                    <Col md={6}>
                      <img
                        className="img-fluid product-img"
                        src={Etf}
                        alt="Etf-etf"
                      />
                    </Col>
                    <Col md={6}>
                      <div className="product-beta">
                        <p>
                        An ETF, also known as an exchange-traded fund is a pooled investment of assets that functions similarly to a mutual fund. Unlike mutual funds, ETFs typically track a specific index, sector, commodity, etc. ETF prices reflect the Net asset value (NAV) of the basket in which it invests...
                          <span onClick={routeChangeETF}>
                            <ReadMore name="Read" />
                          </span>
                        </p>

                        {/* <button>Sign Up</button> */}
                      </div>
                    </Col>
                  </Row>
                </Tab>
              </Tabs>
            </Col>
          </Row>
          <LoginPopup show={show} ref={childRef} />
          </div>
        </Container>
      </section>
    </>
  );
}
export default Products;
